import script from "./udfSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./udfSidebar.vue?vue&type=script&setup=true&lang=js"

import "./udfSidebar.vue?vue&type=style&index=0&id=0600d11f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0600d11f"]])

export default __exports__